import { ICreateResidentParams } from '../types/api/resident/createResident';
import { IUpdateResidentParams } from '../types/api/resident/updateResident';

export const SEX_JA = [
  { key: '-', value: '未選択' },
  { key: 'male', value: '男性' },
  { key: 'female', value: '女性' },
  { key: 'unknown', value: 'その他' },
];

export const SEX_EN = [
  { key: '-', value: 'Not selected' },
  { key: 'male', value: 'Male' },
  { key: 'female', value: 'Female' },
  { key: 'unknown', value: 'Other' },
];
export const MED_SEX_JA = [
  { key: 'male', value: '男性' },
  { key: 'female', value: '女性' },
  { key: 'unknown', value: 'その他' },
];

export const MED_SEX_EN = [
  { key: 'male', value: 'Male' },
  { key: 'female', value: 'Female' },
  { key: 'unknown', value: 'Other' },
];

export const CARE_LEVEL = [
  { key: 1, value: '1' },
  { key: 2, value: '2' },
  { key: 3, value: '3' },
  { key: 4, value: '4' },
  { key: 5, value: '5' },
];

// (2025/06/18) 利用目的削除に伴い現在は不使用
export const PURPOSE_JA = [
  { key: 'toilet', value: '「そろそろ通知」をもとにトイレ誘導' },
  { key: 'diaper', value: '「でたかも通知」をもとにおむつ交換' },
  { key: 'monitoring', value: '排泄パターン把握(モニタリング)' },
];

// (2025/06/18) 利用目的削除に伴い現在は不使用
export const PURPOSE_EN = [
  { key: 'toilet', value: 'Toilet guidance based on "Almost" notification' },
  { key: 'diaper', value: 'Change diapers based on "Check" notification' },
  { key: 'monitoring', value: 'Understanding excretion patterns (monitoring)' },
];

export const DETAKAMO_LOGIC_JA = [
  { key: 'less', value: '動きが少ない人用' },
  { key: 'often', value: 'よく体を動かす人用' },
];

export const DETAKAMO_LOGIC_EN = [
  { key: 'less', value: 'For people with limited mobility' },
  { key: 'often', value: 'For people who are very active' },
];

// 0はnullとして送信する
export const SNOOZETERM_JA = [
  { key: '0', value: 'なし' },
  { key: '5', value: '5分' },
  { key: '10', value: '10分' },
  { key: '15', value: '15分' },
  { key: '30', value: '30分' },
];

// 0はnullとして送信する
export const SNOOZETERM_EN = [
  { key: '0', value: 'No' },
  { key: '5', value: '5 mins' },
  { key: '10', value: '10 mins' },
  { key: '15', value: '15 mins' },
  { key: '30', value: '30 mins' },
];

export const SNOOZEPERIOD_JA = [
  { key: '5', value: '5分' },
  { key: '10', value: '10分' },
  { key: '15', value: '15分' },
  { key: '30', value: '30分' },
  { key: '60', value: '1時間' },
  { key: '120', value: '2時間' },
];

export const SNOOZEPERIOD_EN = [
  { key: '5', value: '5 mins' },
  { key: '10', value: '10 mins' },
  { key: '15', value: '15 mins' },
  { key: '30', value: '30 mins' },
  { key: '60', value: '1 hour' },
  { key: '120', value: '2 hours' },
];

export const INDEPENDENCE_LEVELS = [
  { key: '-', value: '未選択' },
  { key: 'unnecessary', value: '自立' },
  { key: 'part', value: '一部介助' },
  { key: 'whole', value: '全部介助' },
];

// TODO: UTC時間を示すZがついているが、ローカル時間でも使用されているのでZ表記を削る
export const HOURS = [
  { key: '00:00:00Z', value: '00:00' },
  { key: '00:30:00Z', value: '00:30' },
  { key: '01:00:00Z', value: '01:00' },
  { key: '01:30:00Z', value: '01:30' },
  { key: '02:00:00Z', value: '02:00' },
  { key: '02:30:00Z', value: '02:30' },
  { key: '03:00:00Z', value: '03:00' },
  { key: '03:30:00Z', value: '03:30' },
  { key: '04:00:00Z', value: '04:00' },
  { key: '04:30:00Z', value: '04:30' },
  { key: '05:00:00Z', value: '05:00' },
  { key: '05:30:00Z', value: '05:30' },
  { key: '06:00:00Z', value: '06:00' },
  { key: '06:30:00Z', value: '06:30' },
  { key: '07:00:00Z', value: '07:00' },
  { key: '07:30:00Z', value: '07:30' },
  { key: '08:00:00Z', value: '08:00' },
  { key: '08:30:00Z', value: '08:30' },
  { key: '09:00:00Z', value: '09:00' },
  { key: '09:30:00Z', value: '09:30' },
  { key: '10:00:00Z', value: '10:00' },
  { key: '10:30:00Z', value: '10:30' },
  { key: '11:00:00Z', value: '11:00' },
  { key: '11:30:00Z', value: '11:30' },
  { key: '12:00:00Z', value: '12:00' },
  { key: '12:30:00Z', value: '12:30' },
  { key: '13:00:00Z', value: '13:00' },
  { key: '13:30:00Z', value: '13:30' },
  { key: '14:00:00Z', value: '14:00' },
  { key: '14:30:00Z', value: '14:30' },
  { key: '15:00:00Z', value: '15:00' },
  { key: '15:30:00Z', value: '15:30' },
  { key: '16:00:00Z', value: '16:00' },
  { key: '16:30:00Z', value: '16:30' },
  { key: '17:00:00Z', value: '17:00' },
  { key: '17:30:00Z', value: '17:30' },
  { key: '18:00:00Z', value: '18:00' },
  { key: '18:30:00Z', value: '18:30' },
  { key: '19:00:00Z', value: '19:00' },
  { key: '19:30:00Z', value: '19:30' },
  { key: '20:00:00Z', value: '20:00' },
  { key: '20:30:00Z', value: '20:30' },
  { key: '21:00:00Z', value: '21:00' },
  { key: '21:30:00Z', value: '21:30' },
  { key: '22:00:00Z', value: '22:00' },
  { key: '22:30:00Z', value: '22:30' },
  { key: '23:00:00Z', value: '23:00' },
  { key: '23:30:00Z', value: '23:30' },
];

export const LOCAL_HOURS = [
  { key: '00:00:00', value: '00:00' },
  { key: '00:30:00', value: '00:30' },
  { key: '01:00:00', value: '01:00' },
  { key: '01:30:00', value: '01:30' },
  { key: '02:00:00', value: '02:00' },
  { key: '02:30:00', value: '02:30' },
  { key: '03:00:00', value: '03:00' },
  { key: '03:30:00', value: '03:30' },
  { key: '04:00:00', value: '04:00' },
  { key: '04:30:00', value: '04:30' },
  { key: '05:00:00', value: '05:00' },
  { key: '05:30:00', value: '05:30' },
  { key: '06:00:00', value: '06:00' },
  { key: '06:30:00', value: '06:30' },
  { key: '07:00:00', value: '07:00' },
  { key: '07:30:00', value: '07:30' },
  { key: '08:00:00', value: '08:00' },
  { key: '08:30:00', value: '08:30' },
  { key: '09:00:00', value: '09:00' },
  { key: '09:30:00', value: '09:30' },
  { key: '10:00:00', value: '10:00' },
  { key: '10:30:00', value: '10:30' },
  { key: '11:00:00', value: '11:00' },
  { key: '11:30:00', value: '11:30' },
  { key: '12:00:00', value: '12:00' },
  { key: '12:30:00', value: '12:30' },
  { key: '13:00:00', value: '13:00' },
  { key: '13:30:00', value: '13:30' },
  { key: '14:00:00', value: '14:00' },
  { key: '14:30:00', value: '14:30' },
  { key: '15:00:00', value: '15:00' },
  { key: '15:30:00', value: '15:30' },
  { key: '16:00:00', value: '16:00' },
  { key: '16:30:00', value: '16:30' },
  { key: '17:00:00', value: '17:00' },
  { key: '17:30:00', value: '17:30' },
  { key: '18:00:00', value: '18:00' },
  { key: '18:30:00', value: '18:30' },
  { key: '19:00:00', value: '19:00' },
  { key: '19:30:00', value: '19:30' },
  { key: '20:00:00', value: '20:00' },
  { key: '20:30:00', value: '20:30' },
  { key: '21:00:00', value: '21:00' },
  { key: '21:30:00', value: '21:30' },
  { key: '22:00:00', value: '22:00' },
  { key: '22:30:00', value: '22:30' },
  { key: '23:00:00', value: '23:00' },
  { key: '23:30:00', value: '23:30' },
];

// TODO: UTC時間であるZがついているが、ローカル時間でも使用されているのでZ表記を削る
export const CARE_SCHEDULES = [
  { key: '00:00:00Z', value: '0' },
  { key: '01:00:00Z', value: '1' },
  { key: '02:00:00Z', value: '2' },
  { key: '03:00:00Z', value: '3' },
  { key: '04:00:00Z', value: '4' },
  { key: '05:00:00Z', value: '5' },
  { key: '06:00:00Z', value: '6' },
  { key: '07:00:00Z', value: '7' },
  { key: '08:00:00Z', value: '8' },
  { key: '09:00:00Z', value: '9' },
  { key: '10:00:00Z', value: '10' },
  { key: '11:00:00Z', value: '11' },
  { key: '12:00:00Z', value: '12' },
  { key: '13:00:00Z', value: '13' },
  { key: '14:00:00Z', value: '14' },
  { key: '15:00:00Z', value: '15' },
  { key: '16:00:00Z', value: '16' },
  { key: '17:00:00Z', value: '17' },
  { key: '18:00:00Z', value: '18' },
  { key: '19:00:00Z', value: '19' },
  { key: '20:00:00Z', value: '20' },
  { key: '21:00:00Z', value: '21' },
  { key: '22:00:00Z', value: '22' },
  { key: '23:00:00Z', value: '23' },
];

export const BLADDER_THRESHOLD_PERCENTAGE = [
  { key: 10, value: '1' },
  { key: 20, value: '2' },
  { key: 30, value: '3' },
  { key: 40, value: '4' },
  { key: 50, value: '5' },
  { key: 60, value: '6' },
  { key: 70, value: '7' },
  { key: 80, value: '8' },
  { key: 90, value: '9' },
  { key: 100, value: '10' },
];

export const GAS_DURATION = [
  { key: 1, value: '1' },
  { key: 2, value: '2' },
  { key: 3, value: '3' },
  { key: 4, value: '4' },
  { key: 5, value: '5' },
];

export const GAS_STRENGTH = [
  { key: 1, value: '1' },
  { key: 2, value: '2' },
  { key: 3, value: '3' },
  { key: 4, value: '4' },
  { key: 5, value: '5' },
];

export const DEFAULT_RESIDENT_FORM_VALUE: ICreateResidentParams = {
  nursingHomeId: 0,
  nursingHomeUnitId: null,
  nursingHomeUnitName: '',
  name: '',
  lastName: '',
  sex: null,
  roomName: '',
  dfreeDeviceId: null,
  dfreeBDeviceId: null,
  carePlanMemo: '',
  bed: '',
  bladderThresholdPercentage: 60,
  bigBladderNotification: false,
  urinationNotification: false,
  gotUpNotification: false,
  zeroResetNotification: true,
  beginGotUpCheckTerm: '19:00:00Z',
  endGotUpCheckTerm: '07:00:00Z',
  contingencyMode: false,
  detakamoLogic: 'less',
  postureMode: false,
  gasPercentage: null,
  gasCareStatus: null,
  gasLevelStatus: null,
  gasLevelThreshold: null,
  gasPoopedNotification: false,
  gasPredictionNotification: false,
  gasDuration: 3,
  gasStrength: 3,
  purpose: 'monitoring',
  bigBladderSnoozeTerm: 0,
  bigBladderSnoozePeriod: 15,
  urinationSnoozeTerm: 0,
  urinationSnoozePeriod: 15,
  gotUpSnoozeTerm: 0,
  gotUpSnoozePeriod: 15,
  memo: null,
  careSettings: {
    careLevel: null,
    independenceLevel: null,
    beginDiaperMiddleHour: null,
    endDiaperMiddleHour: null,
    beginDiaperNightHour: null,
    endDiaperNightHour: null,
    nursingHomeDiaperIdNoon: null,
    nursingHomePadIdNoonFirst: null,
    nursingHomePadIdNoonSecond: null,
    nursingHomeDiaperIdMiddle: null,
    nursingHomePadIdMiddleFirst: null,
    nursingHomePadIdMiddleSecond: null,
    nursingHomeDiaperIdNight: null,
    nursingHomePadIdNightFirst: null,
    nursingHomePadIdNightSecond: null,
    laxativeId: null,
  },
  goodTreeResidentId: null,
  careDataConnectResidentId: null,
  paramountResidentId: null,
};

export const DEFAULT_RESIDENT_UPDATE_FORM_VALUE: IUpdateResidentParams = {
  id: 0,
  nursingHomeId: 0,
  nursingHomeUnitId: null,
  nursingHomeUnitName: '',
  name: '',
  lastName: '',
  sex: null,
  roomName: '',
  dfreeDeviceId: null,
  dfreeBDeviceId: null,
  carePlanMemo: '',
  bladderThresholdPercentage: 60,
  bigBladderNotification: true,
  urinationNotification: false,
  gotUpNotification: false,
  zeroResetNotification: true,
  beginGotUpCheckTerm: '19:00:00Z',
  endGotUpCheckTerm: '07:00:00Z',
  contingencyMode: false,
  detakamoLogic: 'less',
  postureMode: false,
  gasPercentage: null,
  gasCareStatus: null,
  gasLevelStatus: null,
  gasLevelThreshold: null,
  gasPoopedNotification: false,
  gasPredictionNotification: false,
  gasDuration: 3,
  gasStrength: 3,
  purpose: 'monitoring',
  bigBladderSnoozeTerm: null,
  bigBladderSnoozePeriod: null,
  urinationSnoozeTerm: null,
  urinationSnoozePeriod: null,
  gotUpSnoozeTerm: null,
  gotUpSnoozePeriod: null,
  memo: null,
  careSettings: {
    careLevel: null,
    independenceLevel: null,
    beginDiaperMiddleHour: '06:00:00Z',
    endDiaperMiddleHour: '12:00:00Z',
    beginDiaperNightHour: '12:00:00Z',
    endDiaperNightHour: '23:00:00Z',
    nursingHomeDiaperIdNoon: null,
    nursingHomePadIdNoonFirst: null,
    nursingHomePadIdNoonSecond: null,
    nursingHomeDiaperIdMiddle: null,
    nursingHomePadIdMiddleFirst: null,
    nursingHomePadIdMiddleSecond: null,
    nursingHomeDiaperIdNight: null,
    nursingHomePadIdNightFirst: null,
    nursingHomePadIdNightSecond: null,
    laxativeId: null,
  },
  goodTreeResidentId: null,
  careDataConnectResidentId: null,
  paramountResidentId: null,
};

export interface ILifeResidentForm {
  firstFurigana: string;
  lastFurigana: string;
  serviceCode: string;
  insurerNo: string;
  insuredNo: string;
  birthday: string;
  certifiedDate: string;
  carePeriodStart: string;
  carePeriodEnd: string;
  lifeCareLevel: string;
  impairedElderlyIndependenceDegree: string;
  dementiaElderlyIndependenceDegree: string;
  startDate: string;
  endDate: string;
  deathDate: string;
  remarks: string;
  id: number;
}

export const DEFAULT_LIFE_RESIDENT_FORM_VALUE: ILifeResidentForm = {
  firstFurigana: '',
  lastFurigana: '',
  serviceCode: '',
  insurerNo: '',
  insuredNo: '',
  birthday: '',
  certifiedDate: '',
  carePeriodStart: '',
  carePeriodEnd: '',
  lifeCareLevel: '',
  impairedElderlyIndependenceDegree: '',
  dementiaElderlyIndependenceDegree: '',
  startDate: '',
  endDate: '',
  deathDate: '',
  remarks: '',
  id: 0,
};

export const DFREE_GRAPH_VIEW_TYPE = {
  Value: 'value', // たまり具合
  Volume: 'volume', // 尿量実測値
} as const;
export type DfreeGraphViewType = (typeof DFREE_GRAPH_VIEW_TYPE)[keyof typeof DFREE_GRAPH_VIEW_TYPE];
